
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import { Box } from 'reactjs-admin-lte'
import AutopartStore from '../../stores/AutopartStore'
import SWTWageItemEditModal from './SWTWageItemEditModal'
import WorkDocCategoryModal from './WorkDocCategoryModal'

class SWTWageItemListModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,showEdit:false,query:'',catOptions:[],tableData:[]}

    //this.openPopup() 
  }

  onShow(){
    this.openPopup()
  }

  // openPopup(){
  //   this.setState({loading:true})
  //   let that = this
  //   AutopartStore.loadWageCategory(function(result){
  //     let options = result.data.map((item,index)=>{
  //       return {label:item.name,value:item.id}
  //     })
  //     that.setState({loading:false,catOptions:options})

  //     that.loadWageItemList('-1')
  //   })
  // }

  openPopup(){
    let {type} = this.props
    this.setState({loading:true})
    let that = this
    AutopartStore.loadWageCategory(function(result){
      let options = result.data.map((item,index)=>{
        return {label:item.name,value:item.id}
      })
      that.setState({loading:false,catOptions:options})
      if (type==='damage')
        that.loadDamageItemList('-1')
      else
        that.loadWageItemList('-1')
    })
  }

  loadWageItemList(categoryId,query){
    let that = this
    AutopartStore.loadWageItemList(categoryId,query,function(result){
      that.setState({tableData:result.data,loading:false})
    })
  }

  loadDamageItemList(categoryId,query){
    let that = this
    AutopartStore.loadDamageItemList(categoryId,query,function(result){
      that.setState({tableData:result.data,loading:false})
    })
  }

  onHide(){

  }

  onSelectChange(value){
    let {catSelect} = this.state
    if(value!==null)
      this.loadWageItemList(value.value);
    else
      this.loadWageItemList(-1);
    this.setState({catSelect:value,loading:true})
  }

  onTextChange(e){
    let {catSelect} = this.state
    let query = e.target.value

    if(typeof query!=='undefined' && query.length>2){
      if(typeof catSelect!=='undefined' &&catSelect!==null){
        this.loadWageItemList(catSelect.value,query);
      }else{
        this.loadWageItemList(-1,query);
      }
      this.setState({loading:true})
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    this.refs.wageitemedit.loadItemcode(null)
    this.setState({showEdit:true})
  }

  onEditClick(item){
    this.refs.wageitemedit.loadItemcode(item)
    this.setState({showEdit:true})
  }

  onRowClick(item){
    
    this.props.onSelect(item)
    this.props.onHide()
  }

  onClearClick(){
    this.setState({query:'',catSelect:null})
    this.loadWageItemList('-1')
  }

  onAfterSubmit(){
    this.onClearClick();
  }

  onUpdateCategory(newOptions) {
    this.setState({catOptions:newOptions})
  }

  renderSearch(){
    let {query,catSelect,catOptions} = this.state
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} onChange={this.onSelectChange.bind(this)}/>
        </div> 
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)}/>
          <ButtonToolbar style={{width:'410px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>
            <Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการค่าแรง</Button>
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  renderRowData(){
    let {tableData} = this.state
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.itemcode}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.category_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.description}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{item.price}</td>
        <td className='text-center'><Button onClick={this.onEditClick.bind(this,item)}>แก้ไข</Button></td>
      </tr>
    )) 
  }

  renderSearchResult(){
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th>#ID</th>
            <th>หมวดหมู่</th>
            <th>รายการ</th>
            <th>ราคา</th>
            <th>แก้ไข</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }

  renderModal(){
    let {show} = this.props
    let {loading,showEdit,catOptions} = this.state
    return (
      <Modal show={show} onShow={this.onShow.bind(this)} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหารายการค่าแรง (กดบนแถวเพื่อเลือกรายการ)'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box loading={loading}>
            <Box.Body>
              {this.renderSearch()}
              {this.renderSearchResult()}              
            </Box.Body>
          </Box>            
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }

  renderTable() {
    return(
      <div>
        {this.renderSearch()}
        {this.renderSearchResult()} 
      </div>
    )
  }

  render(){
    let {showEdit,catOptions,showCate} = this.state
    let {mode} = this.props
    return (
      <div>
        {mode==='modal'?
        this.renderModal()
        :this.renderTable()}
        <SWTWageItemEditModal  
          ref={'wageitemedit'} 
          type={this.props.type}
          show={showEdit} 
          catOptions={catOptions} 
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}
        />
        <WorkDocCategoryModal
          show={showCate}
          onHide={()=>{this.setState({showCate:false})}}
          categorys={catOptions}
          onUpdateCategory={this.onUpdateCategory.bind(this)}
        />
      </div>  
    )
  }
}

SWTWageItemListModal.defaultProps = {
  mode: 'modal',
  type: 'wage'
}

export default SWTWageItemListModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWageItemListModal.js